import { v4 as uuidv4 } from 'uuid'

export function joinOwnerWithComma(ownersId) {
  let text = ''

  for (const i in ownersId) {
    text += ownersId[i] + ','
  }

  return text.substring(0, text.length - 1)
}

export function createYoutubeUrl(reference) {
  const youtubeHostUrl = 'https://www.youtube.com/embed/'
  const queryParams = ['rel=0']

  if (!reference || reference === '') return

  let newUrl = youtubeHostUrl + reference

  queryParams.forEach((e, i) => {
    if (i === 0) {
      newUrl = newUrl + '?' + e
    } else {
      newUrl = newUrl + '&' + e
    }
  })

  return newUrl
}

export function viewFile(url) {
  var a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export function download(url, fileName, blank) {
  var a = document.createElement('a')
  a.href = url
  if (blank) a.target = '_blank'
  a.download = fileName // Set the file name.
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export function downloadLink(blob, fileName) {
  const link = document.createElement('a')
  // create a blobURI pointing to our Blob
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  // some browser needs the anchor to be in the doc
  document.body.append(link)
  link.click()
  link.remove()
  // in case the Blob uses a lot of memory
  setTimeout(() => URL.revokeObjectURL(link.href), 7000)
}

export function copyToClipboard(text) {
  var textArea = document.createElement('textarea')

  // Fix probleme when you use copy in dialog modal
  textArea.addEventListener('focusin', e => e.stopPropagation())

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em'
  textArea.style.height = '2em'

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0

  // Clean up any borders.
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent'

  textArea.value = text

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  document.execCommand('copy')

  document.body.removeChild(textArea)
}

export function simulateAsyncCall(status, returnedData) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      switch (status) {
        case 'success':
          resolve({ status: 200, data: returnedData })
          break
        case 'error':
          resolve({ status: 400, message: 'Bad request' })
          break
        default:
          resolve({ status: 500, message: 'Network Error' })
      }
    }, 1500)
  })
}

export function generateUuid() {
  return uuidv4()
    .toUpperCase()
    .split('-')
    .join('')
}

export function getFileExt(file) {
  if (!file) return

  const name = file.name
  const lastDot = name.lastIndexOf('.')

  return name.substring(lastDot + 1)
}
